module.exports = __webpack_public_path__ + "img/B11.bad31bc7.svg";